import { useParams } from 'react-router-dom';
import Theme404 from '../../layout/404';
import phonelog_view from './phonelog-view';

/**
 *   Create index file
 */

export default function PhonelogIndex() {
  let {
    slug = 'list'
  } = useParams();
  let ActualPage: any;
  switch (slug) {
    case 'list':
      ActualPage = phonelog_view;
      break;
    default:
      ActualPage = Theme404;
      break;
  }
  return <>{<ActualPage />}</>;
}